import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {

  botName;
  logs = [];

  constructor(private route: ActivatedRoute, private db: AngularFireDatabase) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.botName = params['botName'];
      this.initDatabase();
    });
  }

  initDatabase() {
    // logs
    this.db.list('/bots/' + this.botName + '/logs',
      ref => ref.limitToLast(2000)
    ).valueChanges().subscribe(logs => {
      this.logs = logs.reverse();
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/components/logs/logs.component.ts